import {FC, useEffect, useState} from 'react'
import {TaskCloneModalFormWrapper} from './TaskCloneModalFormWrapper'
import {Modal} from 'react-bootstrap'
import {ID} from '../../../../../../_metronic/helpers'
import {useSearchParams} from 'react-router-dom'

type Props = {}

const TaskCloneModalWrapper: FC<Props> = ({}) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const cloneTaskIdSearchParam = searchParams.get('cloneTaskId') as ID
  const [open, setOpen] = useState(false)
  useEffect(() => setOpen(!!cloneTaskIdSearchParam), [cloneTaskIdSearchParam])

  function handleClose() {
    let newParams = new URLSearchParams(searchParams)
    newParams.delete('cloneTaskId')
    setSearchParams(newParams)
  }

  return (
    <Modal
      className='modal'
      id='kt_modal_add_task_clone'
      tabIndex={-1}
      dialogClassName='modal-dialog mw-1000px modal-dialog-centered'
      show={open}
      backdrop='static'
      onHide={handleClose}
      enforceFocus={false}
      autoFocus={false}
    >
      <TaskCloneModalFormWrapper handleClose={handleClose} taskId={cloneTaskIdSearchParam} />
    </Modal>
  )
}

export {TaskCloneModalWrapper}

